import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import LinkButton from 'flarum/common/components/LinkButton';
import ExamPage from './components/ExamPage';
import ExamTakePage from './components/ExamTakePage';
import CertificationLookupPage from './components/CertificationLookupPage';
import CertificationBadge from './components/CertificationBadge';
import UserCard from 'flarum/forum/components/UserCard';

app.initializers.add('taro-exam', () => {
  app.routes['exam'] = { path: '/exams', component: ExamPage };
  app.routes['exam.take'] = { path: '/exams/:id/take', component: ExamTakePage };

  // 认证查询已合并到「导师中心」页面（/mentor-center）
  // 保留旧路由作为兼容跳转
  app.routes['certificationLookup'] = { path: '/certification-lookup', component: CertificationLookupPage };

  extend(IndexPage.prototype, 'navItems', function (items) {
    items.add(
      'exam',
      <LinkButton href={app.route('exam')} icon="fas fa-graduation-cap">
        考试中心
      </LinkButton>,
      70
    );
    // 认证查询导航已移除 — 合并到「导师中心」页面
  });

  // 用户卡显示等级信息：学员等级（S） + 导师认证等级（C）
  extend(UserCard.prototype, 'infoItems', function (items) {
    const user = this.attrs.user;
    if (!user) return;

    const swordLevel = user.attribute('taroSwordLevel') || 'S0';
    const wandLevel = user.attribute('taroWandLevel') || 'C0';

    // 从论坛配置读取等级图标（集中管理）
    const levelMeta = app.forum.attribute('taroLevelMeta') || {};
    const swordIcons = (levelMeta.sword && levelMeta.sword.icons) || {};
    const swordIcon = swordIcons[swordLevel] || '🃏';
    const swordTitles = (levelMeta.sword && levelMeta.sword.titles) || {};
    const swordTitle = swordTitles[swordLevel] || swordLevel;

    // 学员等级（S0-S4）
    items.add('taro-sword-level',
      <span className="UserCard-infoItem" style={{ marginRight: '12px' }}>
        <span title={'学员等级 · ' + swordTitle}>{swordIcon} {swordLevel}</span>
      </span>,
      100
    );

    // 导师认证等级（C0-C4）
    if (wandLevel !== 'C0') {
      items.add('taro-cert-badge',
        <CertificationBadge user={user} />,
        99
      );
    } else {
      items.add('taro-wand-level',
        <span className="UserCard-infoItem" style={{ marginRight: '12px' }}>
          <span title="未认证" style={{ color: 'var(--muted-color)' }}>
            <i className="fas fa-certificate" style={{ marginRight: '4px' }} />未认证
          </span>
        </span>,
        99
      );
    }
  });
});
